import React, {useEffect, useState} from "react";
import "./Header.css";
import { Layout, Button, Dropdown, Menu, Modal, Drawer, Input, Select, Form, Row, Col, Tag, notification } from "antd";
import { getUserDetails } from "../../api";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { LogoutOutlined, MenuOutlined,SecurityScanOutlined,ContainerOutlined,ToolOutlined, ReadOutlined, UserOutlined, UserSwitchOutlined, SearchOutlined } from "@ant-design/icons";
import { useLogoutUserMutation, useCheckImpersonationEligibilityMutation } from "../../services/user";
import { trigger401, openNotification } from "../../api";
import { useLocation } from "react-router-dom";
import MailModal from "../MailModal/MailModal";
import { useGetContactIDMutation } from "../../services/user";
import { ReactComponent as ExitIcon } from "../../Assets/images/exit-door-icon.svg"
import Icon from "@ant-design/icons"; 

export default function Header({ title }) {
  const { Header } = Layout;
  const { Search } = Input;
  const { Option } = Select;

  const navigate = useNavigate();
  
  const [urlParams] =  useSearchParams();
  const search_type  = [...urlParams.keys()][0]||'ticket_id';
  const search_string = [...urlParams.values()][0]||'';

  const [showImpersonateModal, setShowImpersonateModal] = useState(false);
  const [visible, setVisible] = useState(false);
  const [searchModal,setSearchModalVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [spinner, startSpinner] = useState(null);

  const isImpersonated = localStorage.getItem("isImpersonated") === "true" ? true : false;

  const [type, setType ] = useState(search_type);
  
  const [triggerGetContactID, {data: contactIDData, isFetching: isFetchingID}] = useGetContactIDMutation();
  const [checkImpersonationEligibility, {isLoading: isCheckingImpersonation}] = useCheckImpersonationEligibilityMutation();

  const [impersonateForm] = Form.useForm();
  
  const [logout, result] = useLogoutUserMutation();
  const userDetails = getUserDetails();
  const name = localStorage.getItem("isImpersonated") ? localStorage.getItem("IMP_givenName") : userDetails.name ? userDetails.name : " ";

  let contactInfo;

  useEffect(() => {

    if(contactIDData) {
      setShowImpersonateModal(false);
      if(contactIDData.data) {
        contactInfo = contactIDData.data;
        console.log(contactInfo);
        if(!contactInfo.ContactID) {
          openNotification("Contact ID not found", "fail", "",5);
          return;
        }
        localStorage.setItem("isImpersonated", true);
        localStorage.setItem("IMP_extension_ContactID", contactInfo.ContactID);
        localStorage.setItem("IMP_givenName", contactInfo.givenName);
        localStorage.setItem("IMP_surname", contactInfo.surname);
        localStorage.setItem("IMP_email", contactInfo.mail);
        localStorage.setItem("IMP_mobilePhone", contactInfo.mobilePhone);
        localStorage.setItem("IMP_ID", contactInfo.id);
        localStorage.setItem("IMP_name", `${contactInfo.givenName} ${contactInfo.surname}`);
        window.location.href = "/datacenters";
      }
    }

  }, [contactIDData])

  async function triggerLogout() {
    try {
      console.log("logout");
      const resp = await logout().unwrap();
      // console.log(resp.data);
      if (resp && resp.success) {
        window.location.href = resp.data;
        return;
      }
    } catch (error) {
      console.log(error);
      trigger401(error);
    } finally {
      localStorage.clear();
      sessionStorage.clear();
    }
  }
  const headerLinks = [
    {
      label: (
        <Link to="/datacenters" className="nav-item">
          Data Centers
        </Link>
      ),
      icon: <ContainerOutlined />,
      key: "/datacenters",
    },
    {
      label: (
        <Link to="/activitylogs" className="nav-item">
          Activity Logs
        </Link>
      ),
      icon: <SecurityScanOutlined />,
      key: "/activitylogs",
    },
    {
      label: (
        <Link to="/hardwaretest" className="nav-item">
          Hardware Test (isok)
        </Link>
      ),
      icon: <ToolOutlined />,
      key: "/hardwaretest",
    },
    {
      label: "Support",
      icon: <ReadOutlined />,
      id:"Support",
      key: "sub1",
      children:[
        {
          label: (
            <a href="https://ft-portal-docs.akamai.com/wiki/" target="_blank" className="nav-item">Documentation</a>
          ),
          key: "/Documentation",
        },
        {
          label: (
            <a href="https://ft-portal-docs.akamai.com/wiki/Category:Field_Technician_training_curriculum.html" target="_blank" className="nav-item" >FT Training</a>
          ),
          key: "/training",
        },
        {
          label: (
            <p style={{margin:"auto"}} onClick={()=>{setIsModalVisible(true)}}>Report a Problem</p>
          ),
          key: "/report"
        }
      ]
    } ,
  ]
  const headerKeys = headerLinks.map((link) => link.key);
  const location = useLocation().pathname;

  const impersonateOnFinish = async (values) => {
    try {
      await checkImpersonationEligibility().unwrap();
      setShowImpersonateModal(false);
      openNotification("Impersonating...", "info", "",10);
      await triggerGetContactID({email: values.impersonatedEmail}).unwrap();
    } catch (error) {
      console.log(error);
      setShowImpersonateModal(false);
      trigger401(error);
    }
  }

  const quit_impersonation = () => {
    localStorage.removeItem("isImpersonated");
    localStorage.removeItem("IMP_extension_ContactID");
    localStorage.removeItem("IMP_givenName");
    localStorage.removeItem("IMP_surname");
    localStorage.removeItem("IMP_email");
    localStorage.removeItem("IMP_mobilePhone");
    localStorage.removeItem("IMP_ID");
    localStorage.removeItem("IMP_name");
    window.location.href = "/datacenters";
  }

  const impersonateItem =  {
    key: "3",
    label: <a href="#!" onClick={() => setShowImpersonateModal(true)}>Impersonate User</a>,
    icon: <UserSwitchOutlined/>
  }

  const exitImpersonation = {
    key: "4",
    label: <a href="#!" onClick={() => quit_impersonation()}>Quit Impersonation</a>,
    icon: <Icon component={ExitIcon} />
  }

  const logoutItem = {
    key: "5",
      label: <Link
      to="/"
      onClick={async (e) => {
        e.preventDefault();
        await triggerLogout();
      }}
      className="nav-item"
    > 
    Logout
    </Link>,
      icon: <LogoutOutlined />
  }

  const items = [
    {
      key: "1",
      label: localStorage.getItem("isImpersonated") ? <div>{localStorage.getItem("IMP_givenName")} {localStorage.getItem("IMP_surname")}<span style={{color:"dimgrey"}}> ( {localStorage.getItem("IMP_extension_ContactID") !== "undefined" ? localStorage.getItem("IMP_extension_ContactID") : ""})</span></div> : <div>{userDetails.name}<span style={{color:"dimgrey"}}>({userDetails.extension_ContactID})</span></div>,
    },
    {
      key: "2",
      label:(
        <Link to="/profile" >
      Profile
    </Link>
    ),
    icon: <UserOutlined/>,
    }
  ]

  const userActions = (
    <Menu
      items={!isImpersonated ? [...items, impersonateItem, logoutItem] : [...items, exitImpersonation, logoutItem]}
    />
  );

  const impersonateModal = (
      <Modal
        visible={showImpersonateModal}
        style={{top: "150px"}}
        width={450}
        footer={null}
        closable={false}
        maskClosable={false}
      >
        <Form
          form={impersonateForm}
          onFinish={impersonateOnFinish}
          labelCol={{ span: 11, offset: 0 }}
          labelWrap
        >
          <Row>
            <Col span={24}>
              <Form.Item
                name="impersonatedEmail"
                rules={[
                  { required: true, message: "Email is required!" },
                  { type: 'email', message: "Plese enter a valid email format"}
                ]}
                >
                <Input placeholder="Enter Email ID of user you wish to impersonate"/>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24} style={{textAlign:"right"}}>
              <Button
                htmlType="button"
                onClick={() => {
                  setShowImpersonateModal(false);
                }}
              >
                Close
              </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isFetchingID || isCheckingImpersonation}
                  style={{
                    margin: '0 8px',
                  }}
                  >
                  Submit
                </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
  );

  const onSearch = (value) => {
    value = value?.trim()
    if(value){
      navigate(`/datacenters/search?${type}=${encodeURIComponent(value)}`)
    }
    setSearchModalVisible(false);
  }

  const searchInput = () => {
    return <Search 
              addonBefore={<Select 
                            bordered={false}
                            onSelect ={(value)=>{setType(value)}}
                            defaultValue={type}
                            size="middle"
                            style={(window.innerWidth > 1200)?{width: "150px", textAlign:"left"}:{}}
                          >
                              <Option value="ticket_id">Ticket ID</Option>
                              <Option value="rma_no">RMA Number</Option>
                              <Option value="rack_no">Rack Number</Option>
                              <Option value="ip">IP Address</Option>
                              <Option value="serial_no">Serial Number</Option>
                              <Option value="tracking_no">Tracking Number</Option>
                          </Select>}
              placeholder="Enter text here..."
              defaultValue={search_string}
              enterButton
              style={(window.innerWidth > 1200)?{width:'auto', paddingTop:"12px"}:{}}
              className="search-input-group"
              size="large"
              onSearch={(value)=>onSearch(value)}
            /> 
  }

  return (
    <>
      <Header className="horizontal-header">
        
        <Button type="primary" onClick={() => setVisible(true)} icon={<MenuOutlined />} className="drawer-button"/>
        <h2 className="header-text"> {title ? title : "Title"}&nbsp;&nbsp;{isImpersonated && <Tag color="orange">Impersonation Mode</Tag>}</h2>

        { 
          <>
            <div style={{position:"fixed",right:"80px"}}>
              {(window.innerWidth > 1200) ?
                searchInput()
                :
                <Button type="primary" shape="circle" icon={<SearchOutlined />} onClick={()=>{setSearchModalVisible(true)}}/>}
            </div>
            {searchModal && 
              <Modal
                visible={searchModal}
                onCancel={()=>{setSearchModalVisible(false)}}
                closable={false} 
                footer={null}
              >
                {searchInput()}
              </Modal>
            }
          </>
        } 

        <Drawer
          placement="left"
          onClose={() => setVisible(false)}
          // onClick={() => setVisible(false)}
          closable={false}
          visible={visible}
          width={200}
          bodyStyle ={{ backgroundColor: "#001628",
                        padding:"20px 0px 0px 0px",
                      }}
        >
          <div className="logo">
                  <a href="/" className="header-logo">
                    <span className="logo">
                      <img
                        src="data:image/png;base64,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"
                        alt="Akamai Technologies"
                      />
                    </span>
                    <span className="cover"></span>
                    <span className="title">Field Tech Portal</span>
                  </a>
                 </div>
          <Menu
            theme="dark"
            mode="inline"
            defaultSelectedKeys={[headerKeys.includes(location) ? location : null]}
            items={headerLinks}
          />
          {isModalVisible && <MailModal isImpersonated={isImpersonated} isVisible={isModalVisible} setIsVisible={setIsModalVisible} />}
        </Drawer>
        <div className="loggedin-user">
          <Dropdown overlay={userActions} trigger={['click']} overlayClassName="dropdown-list" overlayStyle={{position:"fixed"}}>
            <Button className="header-button" shape="circle" size="large">
              {name[0]}
            </Button>
          </Dropdown>
          {impersonateModal}
          
        </div>
       
     </Header>
    </>
  );
}
